import {
  FreeWithPuzzlePro,
  HStack,
  PaidByPuzzle,
  PaidByPuzzlePro,
  Skeleton,
  Text,
  VStack,
} from 'ui_2';
import { useFeeQuery } from '@puzzlehq/frontend-utils';

type Props = {
  onGetProClicked?: () => void;
  functionId: string;
};

export const FeeViewBanner = ({ onGetProClicked, functionId }: Props) => {
  const feeQuery = useFeeQuery({
    programId: import.meta.env.VITE_SQUASH_PROGRAM_ID!,
    functionId,
    network: import.meta.env.VITE_NETWORK!,
  });

  const coverageType = feeQuery.data?.feeCoverageType;
  const fee = feeQuery.data?.fee?.fee.total;
  const covered = feeQuery.data?.covered;

  return (
    <HStack className='w-full max-w-[478px] border-t border-t-gray-200 bg-gray-50 px-4 py-2'>
      <Text font='sm'>Fee</Text>
      <HStack className='flex-grow' />
      <VStack className='justify-end'>
        {(() => {
          if (coverageType === 'all') {
            return <PaidByPuzzle />;
          } else if (fee === undefined) {
            return <Skeleton className='h-4 w-12' />;
          } else {
            return (
              <VStack className='text-right'>
                <Text
                  font='sm'
                  className={`${
                    coverageType === 'pro' && covered ? 'line-through' : ''
                  }`}
                >
                  {fee} ALEO
                </Text>
                {coverageType === 'pro' && covered && <PaidByPuzzlePro />}
                {coverageType === 'pro' && !covered && (
                  <FreeWithPuzzlePro onGetProClicked={onGetProClicked} />
                )}
              </VStack>
            );
          }
        })()}
      </VStack>
    </HStack>
  );
};

export const FeeView = ({ onGetProClicked, functionId }: Props) => {
  const feeQuery = useFeeQuery({
    programId: import.meta.env.VITE_SQUASH_PROGRAM_ID!,
    functionId,
    network: import.meta.env.VITE_NETWORK!,
  });

  const coverageType = feeQuery.data?.feeCoverageType;
  const fee = feeQuery.data?.fee?.fee.total;
  const covered = feeQuery.data?.covered;

  return (
    <HStack className='w-full max-w-[200px]'>
      <Text family='space' color='white'>
        Fee
      </Text>
      <HStack className='flex-grow' />
      <VStack className='justify-end'>
        {(() => {
          if (coverageType === 'all') {
            return <PaidByPuzzle fontColor='white' />;
          } else if (fee === undefined) {
            return <Skeleton className='h-4 w-12' />;
          } else {
            return (
              <VStack className='text-right'>
                <Text
                  family='space'
                  color='white'
                  className={`${
                    coverageType === 'pro' && covered ? 'line-through' : ''
                  }`}
                >
                  {fee} ALEO
                </Text>
                {coverageType === 'pro' && covered && (
                  <PaidByPuzzlePro fontColor='white' />
                )}
                {coverageType === 'pro' && !covered && (
                  <FreeWithPuzzlePro
                    fontColor='white'
                    onGetProClicked={onGetProClicked}
                  />
                )}
              </VStack>
            );
          }
        })()}
      </VStack>
    </HStack>
  );
};
